import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d2945fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "finance" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "财务看板RMB", -1))
const _hoisted_3 = { class: "box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "统计时间", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "对账状态", -1))
const _hoisted_6 = { class: "table" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "dialog-footer" }
const _hoisted_13 = { style: {"display":"flex","justify-content":"center"} }

import cycle from "@/utils/CycleUtils";
import finance from "@/api/finance";
import { onMounted, reactive, ref } from "vue";
import { SettlementBillAdjustRequest } from "@/services/datatype/business/service/settlement/SettlementBillAdjustRequest";
import UserTools from "@/services/session/UserTools";
import { ElMessage } from "element-plus";
import Padding from "@/components/Layout/paging.vue";
//对账状态衰选

export default /*#__PURE__*/_defineComponent({
  __name: 'Account',
  setup(__props) {

const reconciliationSelection = ["全部", "未确认", "已确认", "调整中"];
//时间衰选
const timeSelection = [["全部", "全部"], ...cycle.getCycle(1)];
//确认账单
const centerDialogVisible = ref(false);
//申请金额调整
const confirmBillingDialog = ref(false);
//缓存申请金额数据
const adjustmentAmount = reactive({
  adjustAmount: "",
  reason: "",
  currentAmount: "",
  billId: "",
  period: "",
});
//搜索框内容
//const billId = ref("");
//统计时间
const time = ref("全部");
//对账状态
const reconciliation = ref("全部");
//表格内容
const tableData = ref([]);
const newData = ref([]);
//信息监听
const getDataOne = (data) => {
  newData.value = data;
};
//表格里确认账单
const confirmBilling = (e) => {
  adjustmentAmount.currentAmount = e.settleAmount;
  adjustmentAmount.billId = e.billId;
  adjustmentAmount.period = e.settlementPeriod;
  confirmBillingDialog.value = true;
};
//调整账单
const adjustBill = () => {
  confirmBillingDialog.value = false;
  centerDialogVisible.value = true;
};
//确认账单
const confirmBill = async () => {
  confirmBillingDialog.value = false;
  await finance.confirmBillById(
    Number(adjustmentAmount.period),
    Number(adjustmentAmount.billId)
  );
  newData.value.forEach((value) => {
    if (value.billId === adjustmentAmount.billId) {
      value.syncStatus = 1;
    }
  });
  ElMessage({
    message: "确认账单成功!",
    type: "success",
  });
};
//申请调整
const determine = async () => {
  const SettlementBill = new SettlementBillAdjustRequest();
  SettlementBill.billId = Number(adjustmentAmount.billId);
  SettlementBill.period = Number(adjustmentAmount.period);
  SettlementBill.enterpriseId =
    UserTools.userRoles.roles[
      localStorage.getItem("userRoleIndex")
    ].getEnterpriseId();
  SettlementBill.workerId = UserTools.getUserId();
  SettlementBill.currentAmount = Number(adjustmentAmount.currentAmount);
  SettlementBill.adjustAmount = Number(adjustmentAmount.adjustAmount);
  SettlementBill.reason = adjustmentAmount.reason;
  SettlementBill.createTime = new Date().getTime();
  await finance.requestToAdjustBill(SettlementBill);
  centerDialogVisible.value = false;
  newData.value.forEach((value) => {
    if (value.billId === adjustmentAmount.billId) {
      value.syncStatus = 2;
    }
  });
  ElMessage({
    message: "申请调整金额成功!",
    type: "success",
  });
};
//获取统计时间回调
const getTime = async (val) => {
  if (val === "全部") {
    await getData();
  } else {
    tableData.value = [await finance.getSeason(val)];
  }
};
//对账状态回调
const getReconciliation = async (val) => {
  if (val === 0) {
    await getData();
  } else {
    tableData.value = (await finance.getBillStatus(val - 1)).getPageData();
  }
};
//获取全部消息
const getData = async () => {
  tableData.value = (await finance.getBillAll()).getPageData();
};
//只可以输入数字
const getAdjustAmount = () => {
  let val = adjustmentAmount.adjustAmount;
  let reg = /^[0-9]+(.[0-9]{0,2})?$/;
  if (!val) {
    adjustmentAmount.adjustAmount = "";
  } else if (!isNaN(Number(val))) {
    if (!reg.test(val)) {
      adjustmentAmount.adjustAmount = parseFloat(val).toFixed(2);
    }
  } else {
    adjustmentAmount.adjustAmount = "";
  }
};
onMounted(() => {
  getData();
});
//搜索回调
// const searchBillId = async () => {
//   time.value = "全部";
//   reconciliation.value = "全部";
//   tableData.value = [await finance.getBILLId(billId.value)];
// };
//清空搜索
// const empty = () => {
//   billId.value = "";
//   time.value = "全部";
//   reconciliation.value = "全部";
//   getData();
// };

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_select, {
          modelValue: time.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((time).value = $event)),
          disabled: reconciliation.value != '0' && reconciliation.value !== '全部',
          class: "m-2",
          placeholder: "Select",
          size: "small",
          onChange: getTime
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(timeSelection, (item) => {
              return _createVNode(_component_el_option, {
                key: item[0],
                label: item[0],
                value: item[1]
              }, null, 8, ["label", "value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        _hoisted_5,
        _createVNode(_component_el_select, {
          disabled: time.value !== '全部',
          modelValue: reconciliation.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((reconciliation).value = $event)),
          class: "m-2",
          placeholder: "Select",
          size: "small",
          onChange: getReconciliation
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reconciliationSelection, (item, index) => {
              return _createVNode(_component_el_option, {
                key: item,
                label: item,
                value: index
              }, null, 8, ["label", "value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["disabled", "modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_table, {
        data: newData.value,
        border: "",
        stripe: "",
        height: "440"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "billId",
            label: "结算单号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "settlementPeriod",
            label: "结算周期"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(cycle).timeToCycle(scope.row.settlementPeriod.toString())), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "settleAmount",
            label: "应收金额"
          }),
          _createVNode(_component_el_table_column, {
            prop: "ajustedAmount",
            label: "调整金额"
          }),
          _createVNode(_component_el_table_column, {
            prop: "realAmount",
            label: "实收金额"
          }),
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "账单明细"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_router_link, {
                class: "blue",
                to: { path: '/layout/finance/' + scope.row.settlementPeriod as any }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查看明细")
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "syncStatus",
            label: "对账状态"
          }, {
            default: _withCtx((scope) => [
              (scope.row.syncStatus === 0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "blue",
                    onClick: ($event: any) => (confirmBilling(scope.row))
                  }, "确认账单", 8, _hoisted_7))
                : _createCommentVNode("", true),
              (scope.row.syncStatus === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "已确认"))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, "调整中"))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "invoiceStatus",
            label: "开票状态"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.invoiceStatus === 0
            ? "已开票"
            : scope.row.invoiceStatus === 1
            ? "处理中"
            : "未开票"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "paymentStatus",
            label: "支付状态"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.paymentStatus === 0 ? "待支付" : "已支付"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "paymentStatus",
            label: "电子回单"
          }, {
            default: _withCtx((scope) => [
              (scope.row.paymentStatus === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "未回单"))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, "查看回单"))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(Padding, {
      data: tableData.value,
      "page-size": 10,
      onGetData: getDataOne
    }, null, 8, ["data"]),
    _createVNode(_component_el_dialog, {
      modelValue: centerDialogVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((centerDialogVisible).value = $event)),
      title: "申请调整金额",
      width: "30%",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_12, [
          _createVNode(_component_el_button, { onClick: determine }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          onInput: getAdjustAmount,
          modelValue: adjustmentAmount.adjustAmount,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((adjustmentAmount.adjustAmount) = $event)),
          placeholder: "请输入要申请调整金额!",
          style: {"margin-bottom":"1vw"}
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          modelValue: adjustmentAmount.reason,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((adjustmentAmount.reason) = $event)),
          rows: 3,
          type: "textarea",
          placeholder: "请输入调整金额原因!"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: confirmBillingDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((confirmBillingDialog).value = $event)),
      title: "确认账单",
      width: "30%",
      center: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_button, { onClick: confirmBill }, {
            default: _withCtx(() => [
              _createTextVNode("确认账单")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, { onClick: adjustBill }, {
            default: _withCtx(() => [
              _createTextVNode("调整账单")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})